import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    collapsed: {
      alignSelf: 'center',
    },
    formControlLabel: {
      color: 'white',
    },
    footerSideBar: {
      display: 'flex',
      justifyContent: 'center',
    },
    headerSideBar: {
      alignItems: 'center',
      display: 'flex',
      height: '12vh !important',
      justifyContent: 'center',
    },
    image: {
      filter: 'brightness(1) contrast(300%) invert(1)',
      height: '60%',
      width: '60%',
    },
    imageCt: {
      height: '100%',
      width: '100%',
      borderRadius: '50%',
    },
    logoContainer: {
      alignItems: 'center',
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
    senslaLogo: {
      display: 'flex',
      width: '80%',
      justifyContent: 'center',
    },
    senslaLogoShort: {
      display: 'flex',
      width: '90%',
      justifyContent: 'center',
    },
    sidebar: {
      display: 'flex',
      height: '100vh',
      justifyContent: 'center',
    },
    content: {
      display: 'flex',
      flex: 1,
    },
    top: {},
    bottom: {
      position: 'absolute',
      bottom: '80px',
    },
  })
);
